import CategoryVideo from "./CategoryVideo";
import CategoryFeaturesSwiper from "./CategoryFeaturesSwiper";
import Dropdown from "../../../Form/Dropdown";
import { categories } from "../../../../constants/commonConstants";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const CategoryLayout = () => {
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState();

  const handleSelectedCategory = (category) => {
    console.log("Category selected: ", category);
    setSelectedCategory(category);

    if (category) {
      const encodedCategory = encodeURIComponent(category.name).replace(
        /%20/g,
        "+"
      );
      const url = `/client/find-service-pro?category=${encodedCategory}`;
      console.log("Navigating to: ", url);

      navigate(url);
    }
  };

  return (
    <div className="bg-white py-10 md:py-[88px] flex flex-col w-full gap-16 px-[20px] md:px-[40px] lg:px-[100px]">
      {" "}
      {/*max-w-[1273px] mx-auto */}
      <div className="flex flex-col w-full gap-10">
        <h2 className="font-nonito_sans text-3xl sm:text-4xl lg:text-[42px] font-bold leading-[56px] text-primary">
          Browse By Categories
        </h2>
        <Dropdown
          options={categories}
          defaultOption={selectedCategory}
          placeholder="Select Category"
          idKey="_id"
          displayKey="name"
          onSelect={handleSelectedCategory}
          wrapperClassName="w-full max-w-[745px] mx-auto  font-inter font-medium text-base"
          filterClassName="max-h-[240px] overflow-y-auto scrollbar-no-radius"
          buttonClassName="px-10 border border-primary h-[72px] border-primary rounded-[20px] text-content"
          dropdownClassName="rounded-[24px] shadow-lg"
          optionClassName="px-10 py-3 hover:bg-gray-100 first:rounded-t-[20px] last:rounded-b-[20px]
                       text-content"
        />
        <div className=" lg:mt-10">
          <CategoryFeaturesSwiper />
        </div>
      </div>
      <CategoryVideo />
    </div>
  );
};

export default CategoryLayout;
